// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import pages from './pages';
// import { app } from './lib/app';

Vue.config.productionTip = false;

pages();



// WEBPACK FOOTER //
// ./src/main.js